import { VALUE_MY_AGENT } from "@/components/atoms/ChipSet";
import {
  MENU_ACTION_COPY,
  MENU_ACTION_DELETE,
  MENU_ACTION_PUBLISHED,
  MENU_ACTION_UNPUBLISHED,
  MENU_ICON_CHAT_BOT,
  MENU_ICON_CLOCK,
  MENU_ICON_DASHBOARD,
  MENU_ICON_FLOW,
  MENU_ICON_HEALTH,
  MENU_ICON_MICROSHIP,
  MENU_ICON_MICROSHIP_ACTIVE,
  MENU_ICON_SETTING,
} from "@/components/atoms/IconSet";
import { IMenuBase } from "@/interfaces/IMenu";

export const SORT_BY_MENU: (IMenuBase & { value: string })[] = [
  {
    id: "Latest",
    label: "Latest",
    value: "_id",
  },
  {
    id: "trending",
    label: "Trending",
    value: "remixed_amount",
  },
  {
    id: "name",
    label: "Name",
    value: "name",
  },
];

export const MENU_PRODUCT: IMenuBase = {
  id: "products",
  label: "Products",
  href: "/products",
  subMenu: [
    {
      id: "aiAgents",
      label: "AI Agents",
      href: "/",
      icon: MENU_ICON_MICROSHIP(),
    },
    {
      id: "flow",
      label: "Flow",
      href: "/",
      icon: MENU_ICON_FLOW(),
      isComingSoon: true,
    },
    {
      id: "chatBot",
      label: "Chatbot(RAG)",
      href: "/",
      icon: MENU_ICON_CHAT_BOT(),
      isComingSoon: true,
    },
    {
      id: "dashboard",
      label: "Dashboard Insight",
      href: "/",
      icon: MENU_ICON_DASHBOARD(),
      isComingSoon: true,
    },
  ],
};

export const MENU_AGENT: IMenuBase = {
  id: "agents-hub",
  label: "Agents Hub",
  href: "/explore",
  subMenu: [
    {
      id: SORT_BY_MENU[0].id,
      label: SORT_BY_MENU[0].label,
      href: `/explore?sort=${SORT_BY_MENU[0].id}`,
    },
    {
      id: SORT_BY_MENU[1].id,
      label: SORT_BY_MENU[1].label,
      href: `/explore?sort=${SORT_BY_MENU[1].id}`,
    },
  ],
};

export const MENU_INFO: IMenuBase = {
  id: "info",
  label: "Info",
  href: "/coming-soon",
  subMenu: [
    {
      id: "privacy",
      label: "Privacy",
      href: "/privacy-policy",
    },
    // TODO: Open this when feature is ready
    // {
    //   id: "contact-us",
    //   label: "Contact Us",
    //   href: "#",
    // },
    // {
    //   id: "pricing",
    //   label: "Pricing",
    //   href: "#",
    // },
    // {
    //   id: "doc",
    //   label: "Doc",
    //   href: "#",
    // },
  ],
};

// HEADER
export const MAIN_MENU: IMenuBase[] = [
  MENU_PRODUCT,
  // {
  //   id: "pricing",
  //   label: "Pricing",
  //   href: "/pricing",
  // },
  // {
  //   id: "doc",
  //   label: "Doc",
  //   href: "/doc",
  // },
  // {
  //   id: "contact-us",
  //   label: "Contact Us",
  //   href: "/contact-us",
  // },
];

export const FOOTER_MENU: IMenuBase[] = [MENU_PRODUCT, MENU_AGENT, MENU_INFO];

// MY AGENT
export const MY_AGENT_MENU: Pick<
  IMenuBase,
  "id" | "label" | "href" | "icon" | "iconActive" | "chip"
>[] = [
  // TODO: Open this when Phase 2 is ready
  // {
  //   id: "agent-feeds",
  //   label: "Agent Feeds",
  //   href: "/agent-feeds",
  //   icon: MENU_ICON_NOTE(),
  //   iconActive: MENU_ICON_NOTE("#9D89FC", "1"),
  //   chip: VALUE_MY_AGENT,
  // },
  {
    id: "my-agents",
    label: "My Agents",
    href: "/my-agents",
    icon: MENU_ICON_MICROSHIP(),
    iconActive: MENU_ICON_MICROSHIP_ACTIVE(),
  },
  {
    id: "recent",
    label: "Recent",
    href: "/recent",
    icon: MENU_ICON_CLOCK(),
    iconActive: MENU_ICON_CLOCK("#9D89FC", "1"),
  },
  {
    id: "favorites",
    label: "Favorites",
    href: "/favorites",
    icon: MENU_ICON_HEALTH(),
    iconActive: MENU_ICON_HEALTH("#9D89FC", "1"),
  },
];

// PROFILE DROPDOWN
export const PROFILE_MENU: IMenuBase[] = [
  {
    id: "my-agents",
    label: "My Agents",
    href: "/my-agents",
    icon: MENU_ICON_MICROSHIP(),
    iconActive: MENU_ICON_MICROSHIP_ACTIVE(),
    chip: VALUE_MY_AGENT,
  },
  // TODO: Open this menu when feature is ready
  // {
  //   id: "subscriptions",
  //   label: "Subscriptions",
  //   href: "/subscriptions",
  //   icon: MENU_ICON_BOOK(),
  //   iconActive: MENU_ICON_BOOK("#9D89FC", "1"),
  // },
  {
    id: "favorites",
    label: "Favorites",
    href: "/favorites",
    icon: MENU_ICON_HEALTH(),
    iconActive: MENU_ICON_HEALTH("#9D89FC", "1"),
  },
  {
    id: "setting",
    label: "Settings",
    href: "/settings/account-setting/profile",
    icon: MENU_ICON_SETTING(),
    iconActive: MENU_ICON_SETTING("#9D89FC", "1"),
  },
];

// MORE MENU
export const MENU_MORE_ACTION: IMenuBase[] = [
  {
    id: "publish",
    label: "Publish",
    icon: MENU_ACTION_PUBLISHED(),
  },
  {
    id: "unpublished",
    label: "Unpublished",
    icon: MENU_ACTION_UNPUBLISHED(),
  },
  {
    id: "duplicate",
    label: "Duplicate",
    icon: MENU_ACTION_COPY(),
  },
  {
    id: "delete",
    label: "Delete Agent",
    icon: MENU_ACTION_DELETE(),
  },
];

// FILTER MENU
export const FILTER_MENU: IMenuBase[] = [
  {
    id: "all",
    label: "All",
    // icon: MENU_ACTION_COPY(),
  },
  {
    id: "publish",
    label: "Publish",
    // icon: MENU_ACTION_DELETE(),
  },
  {
    id: "draft",
    label: "Draft",
    // icon: MENU_ACTION_DELETE(),
  },
];
